export const CREATE_PROJECT_NAME = "create_project";
export const CREATE_PROJECT_DESC = `Creates a new project under the specified organization via GraphQL mutation.

Use when the user asks to create a project (Index Worker, Search Analytics, or User Analytics).

Input:
- 'organizationId' (required): Target Organization ID.
- 'name' (required): Project display name.
- 'kind' (required): One of 'INDEX_WORKER' | 'SEARCH_ANALYTICS' | 'USER_ANALYTICS'.
- 'color' (optional): Project color in hex format '#RRGGBB'. If omitted, a color is randomly chosen from an accessible palette.
- 'description' (optional): Project description.
- 'bigQueryId' (optional): Internal BigQuery configuration ID (not a GCP project ID). Required when 'kind' is 'SEARCH_ANALYTICS' or 'USER_ANALYTICS'. Resolve this by calling 'list_bigquery' first and using the 'id' field from the matching configuration.
- 'keyEvents' (optional, UA only): String array of key events, defaults to ['purchase'] when omitted.

Notes:
- This performs a write operation (mutation) and returns the created project's basic fields.
- For SA/UA, if 'bigQueryId' (and 'keyEvents' for UA) are provided, this also creates the corresponding analytics resource and returns its minimal info.
- Returns 'projectPath' (relative link) and 'projectUrl' (absolute when available) to open the created project.`;
